import axios from "axios";
let base = "/cct"; //本地代理

let routesLoaded = false;

export function getRoutesLoaded() {
    return routesLoaded
}
export async function getMenuTree() {
    console.log('getMenuTree被调用',)
    let key = localStorage.getItem('cct-key');
    if (!key) {
        console.warn('没有索引');
        return null;
    }
    let params = { token: key };

    try {
        const resp = await axios.get(`${base}/permission/user/menuTree`)
        routesLoaded = true;

        const res = resp.data
        console.log('菜单res', res)
        if (res.code === 0 && res.data?.menuTree?.left && Array.isArray(res.data.menuTree.left)) {
            let menuTreeLeft = res.data.menuTree.left;
            localStorage.setItem(
                'cct-menu',
                JSON.stringify(res.data.menuTree)
            );
            localStorage.setItem('cct-menubt', JSON.stringify(res.data.buttonList ?? []));
            return menuTreeLeft;
        } else {
            localStorage.removeItem('cct-menu');
            localStorage.removeItem('cct-menubt');
            if (res.code === 401) {
                localStorage.removeItem('cct-key');
            }
            return null; // 返回 null 表示失败
        }
    } catch (error) {
        routesLoaded = false
        console.error('获取菜单权限失败', error);
        localStorage.removeItem('cct-menu');
        localStorage.removeItem('cct-menubt');
        // 返回 null 表示失败
        return null;
    }
}